import React from 'react';


const PerformanceAlertsPanel = ({ alerts }) => {
  const getSeverityConfig = (severity) => {
    const configs = {
      critical: {
        bg: 'bg-error/10',
        border: 'border-error',
        text: 'text-error',
        icon: 'AlertCircle'
      },
      warning: {
        bg: 'bg-warning/10',
        border: 'border-warning',
        text: 'text-warning',
        icon: 'AlertTriangle'
      },
      info: {
        bg: 'bg-primary/10',
        border: 'border-primary',
        text: 'text-primary',
        icon: 'Info'
      }
    };
    return configs?.[severity] || configs?.info;
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const alertTime = new Date(timestamp);
    const diffMinutes = Math.floor((now - alertTime) / 60000);

    if (diffMinutes < 1) return 'Just now';
    if (diffMinutes < 60) return `${diffMinutes}m ago`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${Math.floor(diffHours / 24)}d ago`;
  };

  return;





















































};

export default PerformanceAlertsPanel;